<div>
    <app-services-form></app-services-form>
</div>
<div>
    <app-services-list></app-services-list>
</div>